<template>
  <div class="home-div">
    <SideBar />
    <div class="mid">
      <div class="version-container mbl-no-hover">
        <h1>版本记录</h1>

        <div class="timeline">
          <div v-for="(yearGroup, index) in versionData" :key="index" class="year-section">
            <div class="year-marker">{{ yearGroup.year }}</div>

            <div v-for="(info, infoIndex) in yearGroup.infos" :key="infoIndex" class="version-card">
              <div class="timeline-line">
                <div class="timeline-dot"></div>
              </div>
              <div class="card-content">
                <div class="version-header">
                  <span class="feature-icon">✨</span>
                  <span class="version-date">{{ info.month }}</span>
                  <span class="version-tag">{{ info.version }}</span>
                </div>
                <div class="version-desc">{{ info.desc }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <BottomTip style="position: fixed; bottom: 0;" />
  </div>
</template>

<script>
import SideBar from '@/components/menu/SideBar.vue';
import BottomTip from '@/components/menu/BottomTip.vue';

import { Message } from 'element-ui';
import { getVersionList } from '@/api/verlog.js';

export default {
  name: 'Verlog',
  components: {
    SideBar,
    BottomTip
  },
  data() {
    return {
      versionData: []
    }
  },
  mounted() {
    // 可以在这里添加获取版本数据的API调用
    this.getVersionListInfo();
  },
  methods: {
    async getVersionListInfo() {
      try {
        const resp = await getVersionList();
        if (resp != null && resp.code == 200) {
          this.versionData = resp.data;
        }
      } catch (error) {
        Message.error('网络错误，请稍后重试');
      }
    },
  }
}
</script>

<style scoped>
@media (max-width: 768px) {
  .version-container {
    width: 90% !important;
  }

  .version-card {
    padding: 8px !important;
  }

  .mid {
  height: 80vh !important;
  margin-bottom: 160px !important;
}
}

.home-div {
  width: 100%;
  min-height: 100vh;
  margin: 0;
  padding-top: 80px;
}

.mid {
  display: flex;
  flex-direction: column;
  height: auto;
  justify-content: space-between;
  align-items: center;
  overflow-y: auto;
  margin-bottom: 100px;
}

.version-container {
  width: 60%;
  border-radius: 10px;
  height: auto;
  padding: 10px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  /* margin-bottom: 100px; */
  z-index: 1;
}

.version-container h1 {
  text-align: center;
  color: var(--font-color-1);
  margin-bottom: 10px;
  font-size: 24px;
}

.version-subtitle {
  text-align: center;
  color:  var(--font-color-1);
  margin-bottom: 30px;
  font-size: 14px;
}

/* 时间线样式 */
.timeline {
  position: relative;
  padding: 20px 0;
}

.year-section {
  margin-bottom: 40px;
  position: relative;
}

.year-marker {
  position: sticky;
  top: 20px;
  background: rgba(255, 255, 255, 0.15);
  color:  var(--font-color-1);
  padding: 8px 16px;
  border-radius: 20px;
  font-weight: bold;
  font-size: 16px;
  backdrop-filter: blur(10px);
  z-index: 10;
  margin-bottom: 25px;
  display: inline-block;
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.version-card {
  display: flex;
  margin-bottom: 10px;
  position: relative;
  padding: 8px;
  border-radius: 8px;
  transition: all 0.3s ease;
}

.version-card:hover {
  background: rgba(255, 255, 255, 0.05);
  transform: translateX(5px);
}

.timeline-line {
  position: relative;
  width: 30px;
  display: flex;
  justify-content: center;
  margin-right: 15px;
}

.timeline-dot {
  width: 12px;
  height: 12px;
  background: linear-gradient(135deg, #1890ff, #40a9ff);
  border-radius: 50%;
  position: relative;
  z-index: 2;
  box-shadow: 0 0 0 3px rgba(24, 144, 255, 0.2);
}

.timeline-line::before {
  content: '';
  position: absolute;
  top: 12px;
  bottom: -30px;
  left: 50%;
  width: 2px;
  background: rgba(255, 255, 255, 0.2);
  transform: translateX(-50%);
}

.version-card:last-child .timeline-line::before {
  display: none;
}

.card-content {
  flex: 1;
}

.version-header {
  display: flex;
  justify-content: between;
  align-items: center;
  margin-bottom: 10px;
  gap: 15px;
}

.version-date {
  color:  var(--font-color-1);
  font-weight: 500;
  font-size: 15px;
}

.version-tag {
  background: linear-gradient(135deg, #1890ff, #40a9ff);
  color:  var(--font-color-1);
  padding: 4px 12px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: bold;
}

.version-desc {
  color:  var(--font-color-1);
  line-height: 1.6;
  margin-bottom: 12px;
  font-size: 14px;
}

.version-features {
  margin-top: 10px;
}

.feature-item {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 6px;
  color:  var(--font-color-1);
  font-size: 13px;
}

.feature-icon {
  font-size: 12px;
}

.version-footer {
  text-align: center;
  margin-top: 40px;
  padding-top: 20px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  color:  var(--font-color-1);
  font-size: 12px;
}

/* 滚动条样式 */
.version-container::-webkit-scrollbar {
  width: 6px;
}

.version-container::-webkit-scrollbar-track {
  background: rgba(255, 255, 255, 0.1);
  border-radius: 3px;
}

.version-container::-webkit-scrollbar-thumb {
  background: rgba(24, 144, 255, 0.6);
  border-radius: 3px;
}

.version-container::-webkit-scrollbar-thumb:hover {
  background: rgba(24, 144, 255, 0.8);
}
</style>